const getHeaders = (headers = {}) => {
	const locale = !headers['Accept-Language'] ? ($('html').attr('lang') || 'fr-FR') : headers['Accept-Language'];
	const res = {
		'Content-Type': 'application/json',
		'Accept-Language': locale,
		'Access-Control-Allow-Headers': 'Content-Type',
		...headers,
	}
	return res
}
export default getHeaders;